import { FieldBase } from './field-base';

export class TextboxQuestion extends FieldBase<string> {

    constructor(options: {} = {}) {
        super(options);
    }
}